import type { ComponentType } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { BarChart3, ListChecks } from 'lucide-react';
import type { LucideProps } from 'lucide-react';
import MainLayout from '../../../components/layout/MainLayout';
import styles from './KycModule.module.css';

interface KycTab { to: string; label: string; icon: ComponentType<LucideProps>; end?: boolean }

/**
 * Módulo «Registro biométrico» (solo admin): reemplaza al dashboard KYC independiente.
 * Cada ambiente del portal ve los datos de SU ambiente de AWS (lo decide el backend).
 * El acceso ya está protegido por la ruta (requiredRole="admin") y por cada callable.
 */
const TABS: KycTab[] = [
  { to: '/admin/registro-biometrico', end: true, label: 'Dashboard', icon: BarChart3 },
  { to: '/admin/registro-biometrico/validaciones', label: 'Validaciones', icon: ListChecks },
];

export default function KycLayout() {
  return (
    <MainLayout
      pageTitle="Registro biométrico"
      pageSubtitle="Validaciones de identidad de la app móvil: resultados, tendencias y detalle de cada registro."
    >
      <nav className={styles.tabs} aria-label="Secciones del registro biométrico">
        {TABS.map(({ to, end, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => (isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab)}
          >
            <Icon size={16} aria-hidden />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className={styles.panel}>
        <Outlet />
      </div>
    </MainLayout>
  );
}
